import { useModals } from '@/components/modals/ModalProvider';
import {
	CustomerManagementInfoPayload,
	CustomerShareholderPayload,
} from '@/libs/fleet-api/services/customer';
import { FileSearchOutlined } from '@ant-design/icons';
import { Table, Tabs } from 'antd';
import { FC, useState } from 'react';

type ViewManagementShareholderProps = {
	managements: CustomerManagementInfoPayload<'json'>[];
	shareholders: CustomerShareholderPayload<'json'>[];
	style?: React.CSSProperties;
};

type TabKey = 'pengurus' | 'saham';

const ViewManagementShareholder: FC<ViewManagementShareholderProps> = ({
	managements = [],
	shareholders = [],
	...props
}) => {
	const [activeKey, setActiveKey] = useState<TabKey>('pengurus');

	const { openManagementModal, openShareholderModal } = useModals();

	return (
		<Tabs
			{...props}
			activeKey={activeKey}
			onChange={(activeKey) => setActiveKey(activeKey as TabKey)}
			items={[
				{
					key: 'pengurus',
					label: 'Pengurus',
					children: (
						<Table
							pagination={false}
							bordered
							dataSource={managements.map((data, key) => {
								return { ...data, key };
							})}
							scroll={{ x: 2000 }}
							columns={[
								{
									title: 'Action',
									width: 1,
									align: 'center',
									render: (_, record) => (
										<a
											onClick={(e) => {
												e.preventDefault();
												openManagementModal(record.id);
											}}
										>
											<FileSearchOutlined />
										</a>
									),
								},
								{
									title: 'Nama',
									dataIndex: ['name'],
								},
								{
									title: 'Kewarganegaraan',
									dataIndex: ['citizenship', 'value'],
								},
								{
									title: 'Nationality',
									dataIndex: ['nationality', 'value'],
								},
								{
									title: 'Jenis Identitas',
									dataIndex: ['identityCardType', 'value'],
								},
								{
									title: 'No. ID',
									dataIndex: 'identityNumber',
								},
								{
									title: 'Tanggal Lahir',
									dataIndex: ['dateOfBirth'],
								},
								{
									title: 'Jabatan',
									dataIndex: ['position', 'value'],
								},
								{
									title: 'Alamat Perusahaan',
									dataIndex: 'address',
								},
								{
									title: 'Kode Pos',
									dataIndex: ['postal', 'postalCode'],
								},
								{
									title: 'Kota',
									dataIndex: ['postal', 'cityName'],
								},
								{
									title: 'Kecamatan',
									dataIndex: ['postal', 'districtName'],
								},
								{
									title: 'Kelurahan',
									dataIndex: ['postal', 'locationName'],
								},
								{
									title: 'RT/RW',
									render: (record) => `${record.rt}/${record.rw}`,
								},
								{
									title: 'No. Telepon',
									dataIndex: ['phoneNumber'],
								},
							]}
						/>
					),
				},
				{
					key: 'saham',
					label: 'Pemegang Saham',
					children: (
						<Table
							pagination={false}
							bordered
							dataSource={shareholders.map((data, key) => {
								return { ...data, key };
							})}
							scroll={{ x: 2000 }}
							columns={[
								{
									title: 'Action',
									width: 1,
									align: 'center',
									render: (_, record) => (
										<a
											onClick={(e) => {
												e.preventDefault();
												openShareholderModal(record.id);
											}}
										>
											<FileSearchOutlined />
										</a>
									),
								},
								{
									title: 'Nama',
									dataIndex: ['name'],
								},
								{
									title: 'Tipe Identitas',
									dataIndex: ['shareholderType', 'value'],
								},
								{
									title: 'Kewarganegaraan',
									dataIndex: ['citizenship', 'value'],
								},
								{
									title: 'Jenis Identitas',
									dataIndex: ['identityCardType', 'value'],
								},
								{
									title: 'No. ID',
									dataIndex: ['identityNumber'],
								},
								{
									title: 'Alamat Perusahaan',
									dataIndex: ['address'],
								},
								{
									title: 'Kode Pos',
									dataIndex: ['postal', 'postalCode'],
								},
								{
									title: 'Kota',
									dataIndex: ['postal', 'cityName'],
								},
								{
									title: 'Kecamatan',
									dataIndex: ['postal', 'districtName'],
								},
								{
									title: 'Kelurahan',
									dataIndex: ['postal', 'locationName'],
								},
								{
									title: 'RT/RW',
									render: (record) => `${record.rt}/${record.rw}`,
								},
								{
									title: 'No. Telepon',
									dataIndex: ['phoneNumber'],
								},
								{
									title: 'Kepemilikan Saham (%)',
									render: (record) => `${record.shareholding}%`,
								},
								// {
								// 	title: 'Status',
								// 	render: (record) =>
								// 		record.status ? 'Aktif' : 'Tidak Aktif',
								// },
							]}
						/>
					),
				},
			]}
		/>
	);
};

export default ViewManagementShareholder;
